export enum SortFile {
  Filename = 'filename',
  Type = 'contentType',
  Author = 'author',
  Date = 'date'
}
